import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { Td, Tr } from './styledTableComponents';

interface Props {
  colSpan: number;
}
const EmptyResultsRow: React.LegacyFunctionComponentWithChildren<Props> = ({ colSpan, children }) => {
  return (
    <Tr>
      <Td colSpan={colSpan}>
        <Typography2 component="p" align="center">
          {children}
        </Typography2>
      </Td>
    </Tr>
  );
};

export default EmptyResultsRow;
